const CLEAR_USER_ATTRIBUTES = 'fulcrum/container/User/Login/CLEAR_USER_ATTRIBUTES'
const UPDATE_USER_USERNAME = 'fulcrum/container/User/Login/UPDATE_USER_USERNAME'
const UPDATE_USER_PASSWORD = 'fulcrum/container/User/Login/UPDATE_USER_PASSWORD'
const UPDATE_USER_PROFILE = 'fulcrum/container/User/Login/UPDATE_USER_PROFILE'
const CLEAR_USER_ID = 'fulcrum/container/User/Login/CLEAR_USER_ID'
const UPDATE_USER_ID = 'fulcrum/container/User/Login/UPDATE_USER_ID'
const UPDATE_AUTHENTICATED = 'fulcrum/container/User/Login/UPDATE_AUTHENTICATED'
const CLEAR_SHOW_ERROR = 'fulcrum/container/User/Login/CLEAR_SHOW_ERROR'
const UPDATE_SHOW_ERROR = 'fulcrum/container/User/Login/UPDATE_SHOW_ERROR'

const POST_LOGIN_USER = 'fulcrum/container/User/Login/POST_LOGIN_USER'
const POST_LOGIN_USER_START = 'fulcrum/container/User/Login/POST_LOGIN_USER_START'
const POST_LOGIN_USER_SUCCESS = 'fulcrum/container/User/Login/POST_LOGIN_USER_SUCCESS'
const POST_LOGIN_USER_ERROR = 'fulcrum/container/User/Login/POST_LOGIN_USER_ERROR'

const POST_LOGOUT_USER = 'fulcrum/container/User/Login/POST_LOGOUT_USER'
const POST_LOGOUT_USER_START = 'fulcrum/container/User/Login/POST_LOGOUT_USER_START'
const POST_LOGOUT_USER_SUCCESS = 'fulcrum/container/User/Login/POST_LOGOUT_USER_SUCCESS'
const POST_LOGOUT_USER_ERROR = 'fulcrum/container/User/Login/POST_LOGOUT_USER_ERROR'

const LOGIN_REQUEST_URL = '/users/sign_in'
const LOGOUT_REQUEST_URL = '/users/sign_out'
const DEFAULT_REDIRECT_PATH = '/'

const DEFAULT_REDIRECT = Object.freeze({
  from: {
    pathname: DEFAULT_REDIRECT_PATH
  }
})

export {
  CLEAR_USER_ATTRIBUTES,
  CLEAR_USER_ID,
  UPDATE_AUTHENTICATED,
  UPDATE_USER_USERNAME,
  UPDATE_USER_PASSWORD,
  UPDATE_USER_PROFILE,
  UPDATE_USER_ID,
  POST_LOGIN_USER,
  POST_LOGIN_USER_START,
  POST_LOGIN_USER_SUCCESS,
  POST_LOGIN_USER_ERROR,
  POST_LOGOUT_USER,
  POST_LOGOUT_USER_START,
  POST_LOGOUT_USER_SUCCESS,
  POST_LOGOUT_USER_ERROR,
  LOGIN_REQUEST_URL,
  LOGOUT_REQUEST_URL,
  DEFAULT_REDIRECT,
  CLEAR_SHOW_ERROR,
  UPDATE_SHOW_ERROR,
}
